import React, { useState, useEffect } from "react";

const UniqueAbout: React.FC = () => {
  const [activeSection, setActiveSection] = useState(0);

  const sections = [
    {
      title: "MISSION",
      content: "Empowering people with uninterrupted, portable energy.",
      description:
        "Our mission is to design and develop intelligent energy storage solutions that provide uninterrupted, portable, and dependable power across critical applications. Through advanced battery engineering, disciplined research, and system-level innovation, we aim to strengthen energy resilience, reduce dependence on traditional power sources, and enable reliable energy access wherever continuity matters most.",
      image: "/missionnn.png",
      imageAlt: "Our mission in action - portable energy solutions",
    },
    {
      title: "VALUES",
      image: "/values.png",
      imageAlt: "Our core values - reliability, innovation, safety",
      values: [
        {
          title: "Reliability",
          description: "Consistent and dependable performance",
        },
        {
          title: "Innovation",
          description: "Pioneering energy solutions",
        },
        {
          title: "Safety",
          description: "Safe and secure energy solutions",
        },
      ],
    },
    {
      title: "VISION",
      content: "Building a resilient future powered by innovation.",
      description:
        "To be the world's leading provider of portable power solutions, driving sustainable energy adoption and empowering communities worldwide.",
      image: "/vision.png",
      imageAlt: "Our vision for the future",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSection((prev) => (prev + 1) % sections.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [sections.length]);

  return (
    <div className="min-h-screen bg-white text-stone-900">
      <div className="relative pt-12 px-6 lg:px-20 overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 left-10 w-72 h-72 bg-sky-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-stone-400 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-sky-400 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-500"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto">
          <div className="text-center">
            <button className="rounded-full border-2 border-gray-300 bg-gray-100 px-6 py-2 text-sm font-semibold text-black backdrop-blur-sm transition-all hover:bg-white/20 md:px-8 md:py-3 md:text-base">
              Our Story
            </button>

            <div className="rounded-2xl p-8 shadow-sm mb-12">
              <p className="text-stone-800 leading-relaxed text-lg font-semibold">
                In a world that values energy freedom, Devananta was founded
                with a vision to provide portable power solutions that empower
                individuals and communities. Our journey began when our founders
                recognized the need for resilient energy solutions in an
                increasingly mobile world.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 lg:px-20 bg-white pb-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            {sections.map((section, index) => (
              <div
                key={index}
                className={`bg-white rounded-2xl p-6 border-2 shadow-sm transition-all duration-300 cursor-pointer ${
                  activeSection === index
                    ? "border-sky-500 shadow-lg scale-105"
                    : "border-stone-100 hover:border-sky-300 hover:shadow-md"
                }`}
                onClick={() => setActiveSection(index)}
              >
                <div className="mb-6 rounded-lg overflow-hidden h-48">
                  <img
                    src={section.image}
                    alt={section.imageAlt}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="text-center">
                  <h3 className="text-2xl font-bold text-sky-600 mb-4">
                    {section.title}
                  </h3>
                  <p className="text-lg text-stone-800 font-semibold mb-4 leading-tight">
                    {section.content}
                  </p>
                  <p className="text-stone-600 leading-relaxed text-sm mb-4">
                    {section.description}
                  </p>

                  {section.values && (
                    <div className="mt-4 space-y-3">
                      {section.values.map((value, valueIndex) => (
                        <div
                          key={valueIndex}
                          className="text-left bg-sky-50 rounded-lg p-3 border border-sky-100"
                        >
                          <h4 className="font-bold text-sky-700 text-md mb-1">
                            {value.title}
                          </h4>
                          <p className="text-stone-600 text-xs leading-relaxed">
                            {value.description}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UniqueAbout;
